import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import MonthlyVatReportExpense from './monthly-vat-report-expense.jsx';

export default class MonthlyVatReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: !props.monthlyVatReportData,
      momentFormatString: 'ddd Do MMM YYYY',
      momentFormatStringCSV: 'ddd Do MMM YYYY - HHmmss',
      monthlyVatReportData: props.monthlyVatReportData || [],
      url: props.url ||
        '/api/v1/portal/finance/monthly-vat-report',
      currentMonthYear: props.year || moment().year(),
      currentMonthNumber: props.month || moment().month() + 1,
    };
    this.setCurrentMonth.bind(this);
  }
  getMonthlyVatReportData(monthNumber, monthYear) {
    return fetch(
      this.state.url +
      '/' + monthNumber + '/' + monthYear,
      {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/json'
        },
      }).then((responseText) => {
        let response = responseText.json();
        response.then((response) => {
          this.setState({
            monthlyVatReportData: response,
            isLoading: false
          })
        });
      });
  }
  componentDidMount() {
    if (this.state.isLoading) {
      this.getMonthlyVatReportData(
        this.state.currentMonthNumber,
        this.state.currentMonthYear
      );
    }
  }
  setCurrentMonth(monthNumber, monthYear) {
    this.getMonthlyVatReportData(monthNumber, monthYear);
    this.setState({
      currentMonthNumber: monthNumber,
      currentMonthYear: monthYear,
      isLoading: true
    });
  }
  download(filename, text) {
    text = "Job ID,Vehicle Registration,Net,VAT,Gross,Type\n"+text;
    let element = document.createElement(
      'a'
    );
    element.setAttribute(
      'href',
      'data:text/plain;charset=utf-8,' + encodeURIComponent(text)
    );
    element.setAttribute(
      'download',
      filename
    );
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
  render() {
    let currentMonthNumber = this.state.currentMonthNumber;
    let currentYear = this.state.currentMonthYear;
    let currentMonthName = moment(currentMonthNumber, 'MM').
      format('MMMM');
    let previousYear = currentYear - 1;
    let nextYear = currentYear + 1;
    let previousMonthYear = previousYear;
    let previousMonthNumber = currentMonthNumber - 1;
    let nextMonthNumber = currentMonthNumber + 1;
    let nextMonthYear = currentYear;
    if (currentMonthNumber > 1) {
      previousMonthNumber = currentMonthNumber - 1;
      previousMonthYear = currentYear;
    }
    else {
      previousMonthNumber = 12;
      previousMonthYear = previousYear;
    }
    if (currentMonthNumber < 12) {
      nextMonthNumber = currentMonthNumber + 1;
      nextMonthYear = currentYear;
    }
    else {
      nextMonthNumber = 1;
      nextMonthYear = nextYear;
    }

    let previousMonthName = moment(previousMonthNumber, 'MM').
      format('MMMM');
    let nextMonthName = moment(nextMonthNumber, 'MM').
      format('MMMM');
    let currentJob, currentExpense, currentExpenseToInclude;
    let FuelExpenses = [],
      VehicleExpenses = [],
      TollRoadExpenses = [],
      WaitingTimeExpenses = [],
      StorageExpenses = [],
      BreakdownExpenses = [],
      TravelExpenses = [],
      CarWashExpenses = [],
      PartsExpenses = [],
      TransportsExpenses = [],
      HotelExpenses = [],
      AllOtherExpenses = [];

    let FuelExpensesVatTotal = 0;
    let FuelExpensesNetAmountTotal = 0;
    let FuelExpensesGrossTotal = 0;
    let FuelExpensesTotal = 0;

    let VehicleExpensesVatTotal = 0;
    let VehicleExpensesNetAmountTotal = 0;
    let VehicleExpensesGrossTotal = 0;
    let VehicleExpensesTotal = 0;

    let TollRoadExpensesVatTotal = 0;
    let TollRoadExpensesNetAmountTotal = 0;
    let TollRoadExpensesGrossTotal = 0;
    let TollRoadExpensesTotal = 0;

    let WaitingTimeExpensesVatTotal = 0;
    let WaitingTimeExpensesNetAmountTotal = 0;
    let WaitingTimeExpensesGrossTotal = 0;
    let WaitingTimeExpensesTotal = 0;

    let StorageExpensesVatTotal = 0;
    let StorageExpensesNetAmountTotal = 0;
    let StorageExpensesGrossTotal = 0;
    let StorageExpensesTotal = 0;

    let BreakdownExpensesVatTotal = 0;
    let BreakdownExpensesNetAmountTotal = 0;
    let BreakdownExpensesGrossTotal = 0;
    let BreakdownExpensesTotal = 0;

    let TravelExpensesVatTotal = 0;
    let TravelExpensesNetAmountTotal = 0;
    let TravelExpensesGrossTotal = 0;
    let TravelExpensesTotal = 0;

    let CarWashExpensesVatTotal = 0;
    let CarWashExpensesNetAmountTotal = 0;
    let CarWashExpensesGrossTotal = 0;
    let CarWashExpensesTotal = 0;

    let PartsExpensesVatTotal = 0;
    let PartsExpensesNetAmountTotal = 0;
    let PartsExpensesGrossTotal = 0;
    let PartsExpensesTotal = 0;

    let TransportsExpensesVatTotal = 0;
    let TransportsExpensesNetAmountTotal = 0;
    let TransportsExpensesGrossTotal = 0;
    let TransportsExpensesTotal = 0;

    let HotelExpensesVatTotal = 0;
    let HotelExpensesNetAmountTotal = 0;
    let HotelExpensesGrossTotal = 0;
    let HotelExpensesTotal = 0;

    let AllOtherExpensesVatTotal = 0;
    let AllOtherExpensesNetAmountTotal = 0;
    let AllOtherExpensesGrossTotal = 0;
    let AllOtherExpensesTotal = 0;

    let downloadableCsvDataFuel = "";
    let downloadableCsvDataVehicle = "";
    let downloadableCsvDataTollRoad = "";
    let downloadableCsvDataWaitingTime = "";
    let downloadableCsvDataStorage = "";
    let downloadableCsvDataBreakdown = "";
    let downloadableCsvDataTravel = "";
    let downloadableCsvDataCarWash = "";
    let downloadableCsvDataParts = "";
    let downloadableCsvDataTransports = "";
    let downloadableCsvDataHotel = "";
    let downloadableCsvDataAllOthers = "";
    let downloadableCsvDataAllCodes = "";

    for (let job in this.state.monthlyVatReportData) {
      currentJob = this.state.monthlyVatReportData[job];

      if (currentJob['expenses']) {
        for (let expense in currentJob['expenses']) {
          currentExpense = currentJob['expenses'][expense];
          if (currentExpense['clean']) {
            currentExpenseToInclude = currentExpense['clean'];
            if (currentExpenseToInclude['NOMINAL_CODE'] == '4001') {
              FuelExpenses.push(
                <MonthlyVatReportExpense
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              FuelExpensesVatTotal = (FuelExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              FuelExpensesNetAmountTotal = (FuelExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              FuelExpensesGrossTotal = (FuelExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              FuelExpensesTotal = (FuelExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataFuel = downloadableCsvDataFuel +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";

            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '4000') {
              VehicleExpenses.push(
                <MonthlyVatReportExpense
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              VehicleExpensesVatTotal = (VehicleExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              VehicleExpensesNetAmountTotal = (VehicleExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              VehicleExpensesGrossTotal = (VehicleExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              VehicleExpensesTotal = (VehicleExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataVehicle = downloadableCsvDataVehicle +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '4002' || currentExpenseToInclude['NOMINAL_CODE'] == '4012') {
              TollRoadExpenses.push(
                <MonthlyVatReportExpense
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              TollRoadExpensesVatTotal = (TollRoadExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              TollRoadExpensesNetAmountTotal = (TollRoadExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              TollRoadExpensesGrossTotal = (TollRoadExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              TollRoadExpensesTotal = (TollRoadExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataTollRoad = downloadableCsvDataTollRoad +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '4003') {
              WaitingTimeExpenses.push(
                <MonthlyVatReportExpense
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              WaitingTimeExpensesVatTotal = (WaitingTimeExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              WaitingTimeExpensesNetAmountTotal = (WaitingTimeExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              WaitingTimeExpensesGrossTotal = (WaitingTimeExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              WaitingTimeExpensesTotal = (WaitingTimeExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataWaitingTime = downloadableCsvDataWaitingTime +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '4004') {
              StorageExpenses.push(
                <MonthlyVatReportExpense
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              StorageExpensesVatTotal = (StorageExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              StorageExpensesNetAmountTotal = (StorageExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              StorageExpensesGrossTotal = (StorageExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              StorageExpensesTotal = (StorageExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataStorage = downloadableCsvDataStorage +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '4005') {
              BreakdownExpenses.push(
                <MonthlyVatReportExpense
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              BreakdownExpensesVatTotal = (BreakdownExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              BreakdownExpensesNetAmountTotal = (BreakdownExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              BreakdownExpensesGrossTotal = (BreakdownExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              BreakdownExpensesTotal = (BreakdownExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataBreakdown = downloadableCsvDataBreakdown +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '4006') {
              TravelExpenses.push(
                <MonthlyVatReportExpense
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              TravelExpensesVatTotal = (TravelExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              TravelExpensesNetAmountTotal = (TravelExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              TravelExpensesGrossTotal = (TravelExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              TravelExpensesTotal = (TravelExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataTravel = downloadableCsvDataTravel +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '4007') {
              CarWashExpenses.push(
                <MonthlyVatReportExpense
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              CarWashExpensesVatTotal = (CarWashExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              CarWashExpensesNetAmountTotal = (CarWashExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              CarWashExpensesGrossTotal = (CarWashExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              CarWashExpensesTotal = (CarWashExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataCarWash = downloadableCsvDataCarWash +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '4008') {
              PartsExpenses.push(
                <MonthlyVatReportExpense
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              PartsExpensesVatTotal = (PartsExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              PartsExpensesNetAmountTotal = (PartsExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              PartsExpensesGrossTotal = (PartsExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              PartsExpensesTotal = (PartsExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataParts = downloadableCsvDataParts +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '4009') {
              TransportsExpenses.push(
                <MonthlyVatReportExpense
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              TransportsExpensesVatTotal = (TransportsExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              TransportsExpensesNetAmountTotal = (TransportsExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              TransportsExpensesGrossTotal = (TransportsExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              TransportsExpensesTotal = (TransportsExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataTransports = downloadableCsvDataTransports +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } else if (currentExpenseToInclude['NOMINAL_CODE'] == '7402' || currentExpenseToInclude['NOMINAL_CODE'] == '4011') {
              HotelExpenses.push(
                <MonthlyVatReportExpense
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              HotelExpensesVatTotal = (HotelExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              HotelExpensesNetAmountTotal = (HotelExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              HotelExpensesGrossTotal = (HotelExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              HotelExpensesTotal = (HotelExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataHotel = downloadableCsvDataHotel +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            } else {
              AllOtherExpenses.push(
                <MonthlyVatReportExpense
                  key={'monthly-vat-report-expense-' + currentExpense['label']}
                  currentExpense={currentExpense}
                  currentJob={currentJob}
                />
              );
              AllOtherExpensesVatTotal = (AllOtherExpensesVatTotal) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              AllOtherExpensesNetAmountTotal = (AllOtherExpensesNetAmountTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']);
              AllOtherExpensesGrossTotal = (AllOtherExpensesGrossTotal) + parseFloat(currentExpense['clean']['NET_AMOUNT']) + parseFloat(currentExpense['clean']['TAX_AMOUNT']);
              AllOtherExpensesTotal = (AllOtherExpensesTotal) + parseFloat(currentExpense['clean']['SERVICE_AMOUNT']);

              downloadableCsvDataAllOthers = downloadableCsvDataAllOthers +
                currentJob['job']['id'] + ',' +
                currentJob['job']['registration_number'] + ',' +
                parseFloat(currentExpense['clean']['NET_AMOUNT']).
                  toFixed(2).toString() + ',' +
                parseFloat(currentExpense['clean']['TAX_AMOUNT']).
                  toFixed(2).toString() + ',' +
                (parseFloat(currentExpense['clean']['NET_AMOUNT']) +
                  parseFloat(currentExpense['clean']['TAX_AMOUNT'])).
                  toFixed(2).toString() + ',' +
                currentExpense['clean']['SERVICE_TEXT'] + "\n";
            }

            downloadableCsvDataAllCodes = downloadableCsvDataFuel + 
                                      downloadableCsvDataVehicle +
                                      downloadableCsvDataTollRoad +
                                      downloadableCsvDataWaitingTime +
                                      downloadableCsvDataStorage +
                                      downloadableCsvDataBreakdown +
                                      downloadableCsvDataTravel +
                                      downloadableCsvDataCarWash +
                                      downloadableCsvDataParts +
                                      downloadableCsvDataTransports +
                                      downloadableCsvDataHotel +
                                      downloadableCsvDataAllOthers;
          }
        }
      }
    }

    return (
      (this.state.isLoading) ?
        (<span className="add-loading-text">
          <i className="fa fa-spinner fa-pulse"></i></span>) :
        <div>
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <h2>Finance - Monthly VAT Report</h2>
            </div>
          </div>
          <br /><br /><br />
          <div className="row text-center">
            <div className="col-md-4">
              <a
                href="#"
                className="btn btn-lg btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.setCurrentMonth(
                    previousMonthNumber,
                    previousMonthYear
                  )
                }
                }><i className="fas fa-arrow-left">
                </i> <i className="fas fa-calendar-alt">
                </i> Previous Month
              </a>
            </div>
            <div className="col-md-4">
              <a
                href=""
                onClick={(e) => {
                  e.preventDefault();
                }}
                className="btn btn-lg btn-success">
                <i className="fas fa-calendar-alt">
                </i> &nbsp; {currentMonthName} {currentYear}
              </a>
            </div>
            <div className="col-md-4">
              <a
                href="#"
                className="btn btn-lg btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.setCurrentMonth(
                    nextMonthNumber,
                    nextMonthYear
                  )
                }
                }>
                <i className="fas fa-calendar-alt">
                </i> Next Month <i
                  className="fas fa-arrow-right"></i>
              </a>
            </div>
          </div>
          <br /><br />
          <div className="row text-left">
            <div className="col-md-8">
              <h2>&nbsp; Currently Showing For {currentMonthName} {currentYear} Finance - Monthly VAT Report</h2>
            </div>
            <div className="col-md-3 text-right">
              <button className="btn btn-primary btn-lg" onClick={(e) => {this.download("Monthly VAT Report For All.csv", downloadableCsvDataAllCodes);}}>
                <i className="fa fa-download"></i> Download for ALL Spreadsheet
              </button>
            </div>
          </div>
          <br /><br /><br />

          <div className="row">
            <div className="col-md-12 col-sm-12">
              <h3 className="text-center border-bottom">Fuel</h3>
              <div className="row monthly-vat-report-expense-header-container">
                <div className="col-md-2 col-sm-12 text-left">
                  JOB ID
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  NET
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  VAT
                </div>
                <div className="col-md-1 col-sm-12 text-left">
                  TOTAL
                </div>
                <div className="col-md-1 col-sm-12 text-right">
                  TYPE
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  REG &nbsp;&nbsp;&nbsp;GROSS
                </div>
              </div>
              {FuelExpenses}
              <div className="row">
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    Totals
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {FuelExpensesNetAmountTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {FuelExpensesVatTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {FuelExpensesTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  <h1>
                    {FuelExpensesGrossTotal.toFixed(2).toString()}
                  </h1>
                </div>
              </div>
              <div className="row">
                <div className="col-md-10">
                  <textarea
                    className="form-control form-control-lg csv-textarea"
                    value={downloadableCsvDataFuel}>
                  </textarea>
                </div>
                <div className="col-md-2">
                  <button
                    className="btn btn-primary btn-lg"
                    onClick={(e) => {
                      this.download("Fuel.csv", downloadableCsvDataFuel);
                    }}
                  >
                    <i className="fa fa-download"></i> Download for FUEL Spreadsheet
                  </button>
                </div>
              </div>
            </div>
            {/* Vehicle  */}
            <div className="col-md-12 col-sm-12">
              <br />
              <h3 className="text-center border-bottom">Vehicle Movements</h3>
              <div className="row monthly-vat-report-expense-header-container">
                <div className="col-md-2 col-sm-12 text-left">
                  JOB ID
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  NET
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  VAT
                </div>
                <div className="col-md-1 col-sm-12 text-left">
                  TOTAL
                </div>
                <div className="col-md-1 col-sm-12 text-right">
                  TYPE
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  REG &nbsp;&nbsp;&nbsp;GROSS
                </div>
              </div>
              {VehicleExpenses}
              <div className="row">
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    Totals
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {VehicleExpensesNetAmountTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {VehicleExpensesVatTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {VehicleExpensesTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  <h1>
                    {VehicleExpensesGrossTotal.toFixed(2).toString()}
                  </h1>
                </div>
              </div>
              <div className="row">
                <div className="col-md-10">
                  <textarea
                    className="form-control form-control-lg csv-textarea"
                    value={downloadableCsvDataVehicle}>
                  </textarea>
                </div>
                <div className="col-md-2">
                  <button
                    className="btn btn-primary btn-lg"
                    onClick={(e) => {
                      this.download("Vehicle.csv", downloadableCsvDataVehicle);
                    }}
                  >
                    <i className="fa fa-download"></i> Download for Vehicle Spreadsheet
                  </button>
                </div>
              </div>
            </div>
            {/* /vehicle */}
            {/* TollRoad  */}
            <div className="col-md-12 col-sm-12">
              <br />
              <h3 className="text-center border-bottom">TOLL ROAD</h3>
              <div className="row monthly-vat-report-expense-header-container">
                <div className="col-md-2 col-sm-12 text-left">
                  JOB ID
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  NET
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  VAT
                </div>
                <div className="col-md-1 col-sm-12 text-left">
                  TOTAL
                </div>
                <div className="col-md-1 col-sm-12 text-right">
                  TYPE
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  REG &nbsp;&nbsp;&nbsp;GROSS
                </div>
              </div>
              {TollRoadExpenses}
              <div className="row">
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    Totals
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {TollRoadExpensesNetAmountTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {TollRoadExpensesVatTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {TollRoadExpensesTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  <h1>
                    {TollRoadExpensesGrossTotal.toFixed(2).toString()}
                  </h1>
                </div>
              </div>
              <div className="row">
                <div className="col-md-10">
                  <textarea
                    className="form-control form-control-lg csv-textarea"
                    value={downloadableCsvDataTollRoad}>
                  </textarea>
                </div>
                <div className="col-md-2">
                  <button
                    className="btn btn-primary btn-lg"
                    onClick={(e) => {
                      this.download("Tollroad.csv", downloadableCsvDataTollRoad);
                    }}
                  >
                    <i className="fa fa-download"></i> Download for TOLL ROAD Spreadsheet
                  </button>
                </div>
              </div>
            </div>
            {/* /TollRoad */}
            {/* Waitingtime  */}
            <div className="col-md-12 col-sm-12">
              <br />
              <h3 className="text-center border-bottom">Waitingtime</h3>
              <div className="row monthly-vat-report-expense-header-container">
                <div className="col-md-2 col-sm-12 text-left">
                  JOB ID
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  NET
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  VAT
                </div>
                <div className="col-md-1 col-sm-12 text-left">
                  TOTAL
                </div>
                <div className="col-md-1 col-sm-12 text-right">
                  TYPE
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  REG &nbsp;&nbsp;&nbsp;GROSS
                </div>
              </div>
              {WaitingTimeExpenses}
              <div className="row">
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    Totals
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {WaitingTimeExpensesNetAmountTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {WaitingTimeExpensesVatTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {WaitingTimeExpensesTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  <h1>
                    {WaitingTimeExpensesGrossTotal.toFixed(2).toString()}
                  </h1>
                </div>
              </div>
              <div className="row">
                <div className="col-md-10">
                  <textarea
                    className="form-control form-control-lg csv-textarea"
                    value={downloadableCsvDataWaitingTime}>
                  </textarea>
                </div>
                <div className="col-md-2">
                  <button
                    className="btn btn-primary btn-lg"
                    onClick={(e) => {
                      this.download("Waitingtime.csv", downloadableCsvDataWaitingTime);
                    }}
                  >
                    <i className="fa fa-download"></i> Download for Waitingtime Spreadsheet
                  </button>
                </div>
              </div>
            </div>
            {/* /Waitingtime */}

            {/* Storage  */}
            <div className="col-md-12 col-sm-12">
              <br />
              <h3 className="text-center border-bottom">Storage</h3>
              <div className="row monthly-vat-report-expense-header-container">
                <div className="col-md-2 col-sm-12 text-left">
                  JOB ID
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  NET
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  VAT
                </div>
                <div className="col-md-1 col-sm-12 text-left">
                  TOTAL
                </div>
                <div className="col-md-1 col-sm-12 text-right">
                  TYPE
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  REG &nbsp;&nbsp;&nbsp;GROSS
                </div>
              </div>
              {StorageExpenses}
              <div className="row">
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    Totals
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {StorageExpensesNetAmountTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {StorageExpensesVatTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {StorageExpensesTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  <h1>
                    {StorageExpensesGrossTotal.toFixed(2).toString()}
                  </h1>
                </div>
              </div>
              <div className="row">
                <div className="col-md-10">
                  <textarea
                    className="form-control form-control-lg csv-textarea"
                    value={downloadableCsvDataStorage}>
                  </textarea>
                </div>
                <div className="col-md-2">
                  <button
                    className="btn btn-primary btn-lg"
                    onClick={(e) => {
                      this.download("Storage.csv", downloadableCsvDataStorage);
                    }}
                  >
                    <i className="fa fa-download"></i> Download for Storage Spreadsheet
                  </button>
                </div>
              </div>
            </div>
            {/* /Storage */}

            {/* Breakdown  */}
            <div className="col-md-12 col-sm-12">
              <br />
              <h3 className="text-center border-bottom">Breakdown</h3>
              <div className="row monthly-vat-report-expense-header-container">
                <div className="col-md-2 col-sm-12 text-left">
                  JOB ID
              </div>
                <div className="col-md-2 col-sm-12 text-left">
                  NET
              </div>
                <div className="col-md-2 col-sm-12 text-left">
                  VAT
              </div>
                <div className="col-md-1 col-sm-12 text-left">
                  TOTAL
              </div>
                <div className="col-md-1 col-sm-12 text-right">
                  TYPE
              </div>
                <div className="col-md-4 col-sm-12 text-right">
                  REG &nbsp;&nbsp;&nbsp;GROSS
              </div>
              </div>
              {BreakdownExpenses}
              <div className="row">
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    Totals
                </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {BreakdownExpensesNetAmountTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {BreakdownExpensesVatTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {BreakdownExpensesTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  <h1>
                    {BreakdownExpensesGrossTotal.toFixed(2).toString()}
                  </h1>
                </div>
              </div>
              <div className="row">
                <div className="col-md-10">
                  <textarea
                    className="form-control form-control-lg csv-textarea"
                    value={downloadableCsvDataBreakdown}>
                  </textarea>
                </div>
                <div className="col-md-2">
                  <button
                    className="btn btn-primary btn-lg"
                    onClick={(e) => {
                      this.download("Breakdown.csv", downloadableCsvDataBreakdown);
                    }}
                  >
                    <i className="fa fa-download"></i> Download for Breakdown Spreadsheet
                </button>
                </div>
              </div>
            </div>
            {/* /Breakdown */}

            {/* Travel  */}
            <div className="col-md-12 col-sm-12">
              <br />
              <h3 className="text-center border-bottom">Travel</h3>
              <div className="row monthly-vat-report-expense-header-container">
                <div className="col-md-2 col-sm-12 text-left">
                  JOB ID
              </div>
                <div className="col-md-2 col-sm-12 text-left">
                  NET
              </div>
                <div className="col-md-2 col-sm-12 text-left">
                  VAT
              </div>
                <div className="col-md-1 col-sm-12 text-left">
                  TOTAL
              </div>
                <div className="col-md-1 col-sm-12 text-right">
                  TYPE
              </div>
                <div className="col-md-4 col-sm-12 text-right">
                  REG &nbsp;&nbsp;&nbsp;GROSS
              </div>
              </div>
              {TravelExpenses}
              <div className="row">
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    Totals
                </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {TravelExpensesNetAmountTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {TravelExpensesVatTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {TravelExpensesTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  <h1>
                    {TravelExpensesGrossTotal.toFixed(2).toString()}
                  </h1>
                </div>
              </div>
              <div className="row">
                <div className="col-md-10">
                  <textarea
                    className="form-control form-control-lg csv-textarea"
                    value={downloadableCsvDataTravel}>
                  </textarea>
                </div>
                <div className="col-md-2">
                  <button
                    className="btn btn-primary btn-lg"
                    onClick={(e) => {
                      this.download("Travel.csv", downloadableCsvDataTravel);
                    }}
                  >
                    <i className="fa fa-download"></i> Download for Travel Spreadsheet
                </button>
                </div>
              </div>
            </div>
            {/* /Travel */}

            {/* Car Wash  */}
            <div className="col-md-12 col-sm-12">
              <br />
              <h3 className="text-center border-bottom">Car Wash</h3>
              <div className="row monthly-vat-report-expense-header-container">
                <div className="col-md-2 col-sm-12 text-left">
                  JOB ID
              </div>
                <div className="col-md-2 col-sm-12 text-left">
                  NET
              </div>
                <div className="col-md-2 col-sm-12 text-left">
                  VAT
              </div>
                <div className="col-md-1 col-sm-12 text-left">
                  TOTAL
              </div>
                <div className="col-md-1 col-sm-12 text-right">
                  TYPE
              </div>
                <div className="col-md-4 col-sm-12 text-right">
                  REG &nbsp;&nbsp;&nbsp;GROSS
              </div>
              </div>
              {CarWashExpenses}
              <div className="row">
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    Totals
                </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {CarWashExpensesNetAmountTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {CarWashExpensesVatTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {CarWashExpensesTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  <h1>
                    {CarWashExpensesGrossTotal.toFixed(2).toString()}
                  </h1>
                </div>
              </div>
              <div className="row">
                <div className="col-md-10">
                  <textarea
                    className="form-control form-control-lg csv-textarea"
                    value={downloadableCsvDataCarWash}>
                  </textarea>
                </div>
                <div className="col-md-2">
                  <button
                    className="btn btn-primary btn-lg"
                    onClick={(e) => {
                      this.download("Car-Wash.csv", downloadableCsvDataCarWash);
                    }}
                  >
                    <i className="fa fa-download"></i> Download for Car Wash Spreadsheet
                </button>
                </div>
              </div>
            </div>
            {/* /Car Wash */}

            {/* Parts  */}
            <div className="col-md-12 col-sm-12">
              <br />
              <h3 className="text-center border-bottom">Parts</h3>
              <div className="row monthly-vat-report-expense-header-container">
                <div className="col-md-2 col-sm-12 text-left">
                  JOB ID
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  NET
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  VAT
                </div>
                <div className="col-md-1 col-sm-12 text-left">
                  TOTAL
                </div>
                <div className="col-md-1 col-sm-12 text-right">
                  TYPE
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  REG &nbsp;&nbsp;&nbsp;GROSS
                </div>
              </div>
              {PartsExpenses}
              <div className="row">
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    Totals
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {PartsExpensesNetAmountTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {PartsExpensesVatTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {PartsExpensesTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  <h1>
                    {PartsExpensesGrossTotal.toFixed(2).toString()}
                  </h1>
                </div>
              </div>
              <div className="row">
                <div className="col-md-10">
                  <textarea
                    className="form-control form-control-lg csv-textarea"
                    value={downloadableCsvDataParts}>
                  </textarea>
                </div>
                <div className="col-md-2">
                  <button
                    className="btn btn-primary btn-lg"
                    onClick={(e) => {
                      this.download("Parts.csv", downloadableCsvDataParts);
                    }}
                  >
                    <i className="fa fa-download"></i> Download for Parts Spreadsheet
                  </button>
                </div>
              </div>
            </div>
            {/* /Parts */}

            {/* Transport Services  */}
            <div className="col-md-12 col-sm-12">
              <br />
              <h3 className="text-center border-bottom">Transport Services</h3>
              <div className="row monthly-vat-report-expense-header-container">
                <div className="col-md-2 col-sm-12 text-left">
                  JOB ID
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  NET
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  VAT
                </div>
                <div className="col-md-1 col-sm-12 text-left">
                  TOTAL
                </div>
                <div className="col-md-1 col-sm-12 text-right">
                  TYPE
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  REG &nbsp;&nbsp;&nbsp;GROSS
                </div>
              </div>
              {TransportsExpenses}
              <div className="row">
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    Totals
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {TransportsExpensesNetAmountTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {TransportsExpensesVatTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {TransportsExpensesTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  <h1>
                    {TransportsExpensesGrossTotal.toFixed(2).toString()}
                  </h1>
                </div>
              </div>
              <div className="row">
                <div className="col-md-10">
                  <textarea
                    className="form-control form-control-lg csv-textarea"
                    value={downloadableCsvDataTransports}>
                  </textarea>
                </div>
                <div className="col-md-2">
                  <button
                    className="btn btn-primary btn-lg"
                    onClick={(e) => {
                      this.download("Transport-Services.csv", downloadableCsvDataTransports);
                    }}
                  >
                    <i className="fa fa-download"></i> Download for Transport Services Spreadsheet
                  </button>
                </div>
              </div>
            </div>
            {/* /Transport Services */}

            {/* Hotel */}
            <div className="col-md-12 col-sm-12">
              <br />
              <h3 className="text-center border-bottom">Hotel</h3>
              <div className="row monthly-vat-report-expense-header-container">
                <div className="col-md-2 col-sm-12 text-left">
                  JOB ID
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  NET
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  VAT
                </div>
                <div className="col-md-1 col-sm-12 text-left">
                  TOTAL
                </div>
                <div className="col-md-1 col-sm-12 text-right">
                  TYPE
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  REG &nbsp;&nbsp;&nbsp;GROSS
                </div>
              </div>
              {HotelExpenses}
              <div className="row">
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    Totals
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {HotelExpensesNetAmountTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {HotelExpensesVatTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {HotelExpensesTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  <h1>
                    {HotelExpensesGrossTotal.toFixed(2).toString()}
                  </h1>
                </div>
              </div>
              <div className="row">
                <div className="col-md-10">
                  <textarea
                    className="form-control form-control-lg csv-textarea"
                    value={downloadableCsvDataHotel}>
                  </textarea>
                </div>
                <div className="col-md-2">
                  <button
                    className="btn btn-primary btn-lg"
                    onClick={(e) => {
                      this.download("Hotel.csv", downloadableCsvDataHotel);
                    }}
                  >
                    <i className="fa fa-download"></i> Download for Hotel Spreadsheet
                  </button>
                </div>
              </div>
            </div>
            {/* /Hotel */}

            <div className="col-md-12 col-sm-12">
              <br />
              <h3 className="text-center border-bottom">All other Expenses</h3>
              <div className="row monthly-vat-report-expense-header-container">
                <div className="col-md-2 col-sm-12 text-left">
                  JOB ID
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  NET
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  VAT
                </div>
                <div className="col-md-1 col-sm-12 text-left">
                  TOTAL
                </div>
                <div className="col-md-1 col-sm-12 text-right">
                  TYPE
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  REG &nbsp;&nbsp;&nbsp;GROSS
                </div>
              </div>
              {AllOtherExpenses}
              <div className="row">
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    Totals
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {AllOtherExpensesNetAmountTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {AllOtherExpensesVatTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-2 col-sm-12 text-left">
                  <h1>
                    {AllOtherExpensesTotal.toFixed(2).toString()}
                  </h1>
                </div>
                <div className="col-md-4 col-sm-12 text-right">
                  <h1>
                    {AllOtherExpensesGrossTotal.toFixed(2).toString()}
                  </h1>
                </div>
              </div>
              <div className="row">
                <div className="col-md-10">
                  <textarea
                    className="form-control form-control-lg csv-textarea"
                    value={downloadableCsvDataAllOthers}>
                  </textarea>
                </div>
                <div className="col-md-2">
                  <button
                    className="btn btn-primary btn-lg"
                    onClick={(e) => {
                      this.download("others.csv", downloadableCsvDataAllOthers);
                    }}
                  >
                    <i className="fa fa-download"></i> Download for Spreadsheet
                  </button>
                </div>
              </div>
            </div>

          </div>
          <br /><br /><br />
        </div>
    );
  }
}
if (document.getElementById(
  'react-component-g4-logistics-portal-finance-monthly-vat-report')) {
  ReactDOM.render(
    <MonthlyVatReport
      message_if_none='Nothing to report on.'
    />,
    document.getElementById(
      'react-component-g4-logistics-portal-finance-monthly-vat-report'
    )
  );
}
